import { createAsyncThunk } from "@reduxjs/toolkit";
import HelpDeskAPI, { HelpDeskApiUrls } from "../API/HelpDeskAPI";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const helpDeskAPI = new HelpDeskAPI(apiHelper, cache);

export const getMyHelpRequests = createAsyncThunk(
  HelpDeskApiUrls.getMyHelpRequests,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await helpDeskAPI.getMyHelpRequests(payload, token);

    return response;
  }
);
